/** Focus / solid zone split + "worth improving" floors. */

/** Unit: ms. Default: 100. Gains below this are noise — never a focus card. */
export const SOLID_TINY_LOSS_MS = 100
/** Unit: zone-average %. Default: 90. A zone must average at least this to
 * be called solid (owner-locked, pass 12). */
export const SOLID_MIN_ZONE_PCT = 90
/** Unit: ms. Default: 300. ...and leave less than this on the table. */
export const SOLID_MAX_TIME_LOSS_MS = 300
/** Unit: zones. Default: 4. Focus shows at most this many; rest → improve. */
export const FOCUS_MAX_ZONES = 4
/** Unit: ms. Default: 100. "Worth ~X.Xs" text only surfaces above this
 * (mobile/web parity — both clients import it). */
export const MIN_WORTH_MS = 100
